<template lang="html">
  <div>
    <v-form
      ref="approvalLevelForm"
    >
      <v-data-iterator
        :items="leaveTypes"
        :hide-default-footer="true"
        disable-pagination
        item-key="schema_name"
      >
        <template>
          <v-row>
            <v-col
              v-for="(leaveType,index) in leaveTypes"
              :key="index"
              cols="12"
              md="6"
            >
              <v-card class="mx-6">
                <v-card-title style="padding-top:0;padding-bottom:0;margin:0">
                  <span class="title v-label theme--light pt-3">Leave Type: {{ leaveType.name }}</span>
                </v-card-title>

                <v-divider />
                <v-list
                  dense
                >
                  <v-list-item
                    class=""
                  >
                    <v-list-item-content
                      class="py-0"
                    >
                      Approval Level:
                    </v-list-item-content>
                    <v-text-field
                      v-model="leaveType.level"
                      :rules="[rules.required,rules.min,rules.max]"
                      max="2"
                      min="1"
                      dense
                      class="centered-input"
                      type="number"
                    />
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-form>

    <v-card-actions>
      <v-spacer />
      <v-btn
        :disabled="progressing"
        text
        @click="closeDialog"
      >
        Close
      </v-btn>
      <v-btn
        :disabled="loading"
        :loading="progressing"
        color="success"
        @click="submitForm"
      >
        Update
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  export default {
    props: {
      position: { 
        type: Object,
        required: true,
      },
    },   
    data () {
      return {
        loading: false,
        progressing: false,
        leaveTypes: [],    
        rules: {
          required: value => !!value || 'Required.',     
          min: value => value >= 1 || 'Minimum number is 1',      
          max: value => value <= 2 || 'Max number is 2',      

        },      
      }
    },
    watch: {     
      
    },
    created () {
      this.loading = true
      this.loadData()
    },
    methods: {
      closeDialog () {
        this.$emit('close-dialog')
      },
      loadData () {
        this.$http.all([
          this.$api.leaveTypes().list(),
          this.$api.positionLeaveApprovalLevels().list(this.position.id),
        ])
          .then(this.$http.spread((leaveTypes, leaveApprovalLevels) => {
            this.leaveTypes = leaveTypes.data.map((leaveType) => {
              return {
                id: leaveType.id,
                name: leaveType.name,
                level: 1,
              }
            })

            leaveApprovalLevels.data.forEach((leaveApprovaLevel) => {
              let activeLeaveTypeIndex = this.leaveTypes.findIndex((p) => {
                if (!leaveApprovaLevel.approvable) {
                  return false
                }
                return p.id === leaveApprovaLevel.approvable.id
              })

              if (activeLeaveTypeIndex >= 0) {
                this.leaveTypes[activeLeaveTypeIndex].level = leaveApprovaLevel.level
              }
            })
            this.loading = false
          }))
      },
      submitForm () {
        if (this.$refs.approvalLevelForm.validate()) {
          this.progressing = true
          this.$api.positionLeaveApprovalLevels().update(this.position.id, this.prepareFormData())
            .then(response => {
              if (response.status === 200) {
                this.$snack({ message: response.data.status })
              }
            })
            .catch(error => {
              if (error.response.status === 422) {
                this.$snack({ 
                  color: 'error',
                  message: error.message, 
                })
              }
            })
            .then(() => {
              this.progressing = false
            })
        }
      },
      prepareFormData () {
        return this.leaveTypes.map((leaveType) => {
          return {
            id: leaveType.id,
            level: leaveType.level,
          }
        })
      },
    }, 
  }
</script>

<style lang='css' scoped>
::v-deep .centered-input input {
    text-align: center
  }
</style>
